import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import useTokenSettings from "./useTokenSettings";
import SortableTokenRow from "./SortableTokenRow";

export default function SortableTokenTable({ onEdit, onDelete }) {
  const { contracts, handleDragEnd, companyContracts, getOrderedContracts, toggleSmartContract, isCompanyOwned } = useTokenSettings();
  const enabledCount = contracts.filter((c) => companyContracts?.[c.id] !== undefined).length;
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <div className="mt-4 overflow-hidden rounded-xl border border-gray-200">
        <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3">
          <div className="text-sm font-medium text-gray-700">Tokens list</div>
          <div className="text-xs text-gray-500">
            <span className="font-semibold text-blue-700">{enabledCount}</span> enabled of {contracts?.length || 0}
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-50 uppercase">
              <tr>
                <th className="py-3 px-4 text-left text-xs font-semibold tracking-wider text-gray-500">
                  Name
                </th>
                <th className="py-3 px-4 text-left text-xs font-semibold tracking-wider text-gray-500">Address</th>
                <th className="py-3 px-4 text-right text-xs font-semibold tracking-wider text-gray-500 w-[180px]">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y text-gray-600">
              <SortableContext
                items={contracts.filter((c) => companyContracts[c.id]).map((c) => c.id)}
                strategy={verticalListSortingStrategy}
              >
                {getOrderedContracts()?.map((contract) => (
                  <SortableTokenRow
                    key={contract.id}
                    contract={contract}
                    companyContracts={companyContracts}
                    onToggle={toggleSmartContract}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    isOwned={isCompanyOwned(contract)}
                    isDraggable={companyContracts[contract.id] !== undefined}
                  />
                ))}
              </SortableContext>
            </tbody>
          </table>
        </div>
      </div>
    </DndContext>
  );
}
